// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"548":"e331ab0b","9242":"951eed68"}[chunkId] + ".chunk.css";
};